import React from "react";
import { GlobalContainer } from "../../Global/layout";
import { LineHeading } from "../../LineHeading";
import { StyledHeadingh2 } from "../../Global/headings";
import { IndustryDescription, Logo, LogoContainer } from "./style";
import { BlackButtonLink } from "../../Global/button";

const PhaseEBookIndustry = ({ data, sectionCount }: any) => {
  return (
    <section className="light">
      <GlobalContainer>
        <LineHeading title={data?.lineHeading} number={sectionCount} />
        <StyledHeadingh2 text={data?.heading} />
        <IndustryDescription
          data-aos="fade-up"
          dangerouslySetInnerHTML={{ __html: data?.content }}
        />
        <BlackButtonLink data-aos="fade-up" to="#Form">
          {data?.cta?.title}
        </BlackButtonLink>

        <LogoContainer data-aos="fade-up" gutter={20}>
          {data?.technologyIcons?.map((item: any, index: number) => {
            return (
              <Logo key={index} xs={12} sm={12} md={12} lg={6} xl={6}>
                <img src={item.mediaItemUrl} alt={item.altText} />
              </Logo>
            );
          })}
        </LogoContainer>
      </GlobalContainer>
    </section>
  );
};

export default PhaseEBookIndustry;
